import React, { useEffect, useRef, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import FieldArea from "../../../../CustomComponents/FieldText";
import ReactSelect from "react-select";
import axiosInstance from "../../../../../redux/api";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import {
  getIndustry,
  getSubcategary,
  getWithParentCategary,
} from "../../../../../redux/categary/action";
import { descriptionvalidation, lastdatevalidation, titlevalidation } from "../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import ChoosePostType from "../../../../Common/ChoosePostType";
import CommonIndustryOption from "../../../../Common/CommonIndustryOption";
import CommissionNote from "../../../../Common/ImportantNote/CommissionNote";

const formdatatomap = [
  { title: (<>Choose post type <AsteriskLabel /></>), name: "type", placeholder: "Choose post type" },
  {
    title: (<>Write a title for your post this <AsteriskLabel /></>),
    name: "title",
    placeholder: "Enter Title",
  },
  {
    title: (<>Select Industries <AsteriskLabel /></>),
    name: "industry_id",
    placeholder: "Select An Option",
  },
  {
    title: (<>Select Category <AsteriskLabel /></>),
    name: "category_id",
    placeholder: "Select An Option",
  },

  { title: "Prize money", name: "price", placeholder: "Enter Budget in $" },
  {
    title: (<>Last date of entry <AsteriskLabel /></>),
    name: "last_date",
    placeholder: "Enter last date of entry (DD/MM/YY)",
  },
  {
    title: (<>Win business Opportunities (WBO) Description <AsteriskLabel /></>),
    name: "description",
    placeholder: "Enter detailed Win business Opportunities (WBO) description",
  },
];

const getTodayDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
const validationSchema = Yup.object().shape({
  type: Yup.string().required("This is required"),
  title: titlevalidation,
  description: descriptionvalidation,
  category_id: Yup.string().required("Category is required"),
  industry_id: Yup.string().required("Industry is required"),
  // industry_id: Yup.string().required("This is required"),
  // sub_category_id: Yup.string().required('This is required'),
  price: Yup.number()
    .required("This is required")
    .moreThan(0, "Duration must be greater than 0")
    .typeError("Duration must be a number"),
  last_date: lastdatevalidation,
});


const CAboutContest = ({ formData, setFormData, nextPage }) => {
  const formikRef = useRef(null);
  const dispatch = useDispatch();
  const path = "Assets/scss/FirstTimeUsers.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const initialValues = {
    type: formData?.type,
    title: formData?.title,
    industry_id: formData?.industry_id,
    category_id: formData?.category_id,
    sub_category_id: formData?.sub_category_id,
    price: formData?.price,
    last_date: formData?.last_date,
    description: formData?.description,
  };

  const [parentid, setParentid] = useState("");
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(formData?.category_id);
  const [subcategory, setSubcategory] = useState([]);
  const [selectCatgory, setselectCatgory] = useState(formData.category_index);
  const [selectSubcategory, setSelectSubcategory] = useState(
    formData.subcategory_index
  );
  const [industrySelected, setIndustrySelected] = useState("");


  useEffect(() => {
    dispatch(getIndustry());
  }, [])

  useEffect(() => {
    industrySelected && dispatch(getWithParentCategary(industrySelected)).then((res) => {
      setCategory(res?.response);
    });
  }, [industrySelected]);

  useEffect(() => {
    if (parentid) {
      axiosInstance
        .get(`category?type=3&parent_id=${parentid}`)
        .then((response) => {
          setSubcategory(response?.data?.response);
        });
    }
  }, [parentid]);

  useEffect(() => {
    industrySelected && dispatch(getWithParentCategary(industrySelected));
  }, [industrySelected]);

  useEffect(() => {
    selectCatgory && dispatch(getSubcategary(selectCatgory.value));
  }, [selectCatgory]);

  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));

    nextPage();
    setLoading(false);
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const TheIndustryList = useSelector(
    ({ categary: { industrylist } }) => industrylist
  );

  return (
    <div className="app-container " >
      <div className="col-lg-10 mx-auto expert-flow">
        <div className="col-lg-10 mx-auto">
          <div className="row about-row">
            <div className="col-lg-4 col-md-5 p-0 about-left">
              <h6>
                01/03<span>Create a post</span>
              </h6>
              <h2>Let’s create your post with a title first</h2>
              <p>Choose a clear and strong title</p>
            </div>
            <div className="col-lg-6 col-md-7 about-right">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                innerRef={formikRef}
              >
                {(formik) => (
                  <Form>
                    { }
                    <div>
                      {formdatatomap.map((prop, key) => {
                        if (prop.name == "type") {
                          return (
                            <div>
                              <div key={key} className="form-group">
                                <ChoosePostType title={prop.title} />
                                <div className="checkbox-label">
                                  <label className="checkbox-container">
                                    <Field
                                      type="radio"
                                      name={prop.name}
                                      checked={formik.values[prop.name] == 1}
                                      value="1"
                                      onChange={handleChange}
                                    />
                                    <span className="checkmark">Post & Browse Projects (PBP)</span>
                                  </label>
                                  <label className="checkbox-container">
                                    <Field
                                      type="radio"
                                      name={prop.name}
                                      checked={formik.values[prop.name] == 2}
                                      value="2"
                                      onChange={handleChange}
                                    />
                                    <span className="checkmark">Win-Business-Opportunities (WBO)</span>
                                  </label>
                                  <label className="checkbox-container">
                                    <Field
                                      type="radio"
                                      name={prop.name}
                                      checked={formik.values[prop.name] == 3}
                                      value="3"
                                      onChange={handleChange}
                                    />
                                    <span className="checkmark">
                                      Part-Time-Job (PTJ)
                                    </span>
                                  </label>
                                </div>
                                <ErrorMessage
                                  name={prop.name}
                                  component="div"
                                  className="error"
                                />
                              </div>
                              <CommissionNote type={'create_contest'} item={"contest"} />
                            </div>
                          );
                        }
                        if (prop.name == "industry_id") {
                          return (
                            <CommonIndustryOption
                              key={key}
                              options={TheIndustryList}
                              formik={formik}
                              prop={prop}
                              setSelectedIndustry={setIndustrySelected}
                              setSelectCategory={setselectCatgory}
                            />
                          );
                        }

                        if (prop.name == "category_id") {
                          return (
                            <>
                              <div className="row" key={key}>
                                <div className="form-group col-md-6">
                                  <label>{prop.title}</label>
                                  <ReactSelect
                                    options={
                                      Array.isArray(category) &&
                                      category.map((lang) => ({
                                        value: lang.id,
                                        label: lang.title,
                                      })) || []
                                    }
                                    placeholder={prop.placeholder}
                                    value={selectCatgory || []}
                                    onChange={(options) => {
                                      setselectCatgory(options);
                                      setParentid(options.value);
                                      setSelectSubcategory("");
                                      formik.setFieldValue(
                                        "category_index",
                                        options
                                      );
                                      formik.setFieldValue(
                                        prop.name,
                                        options.value
                                      );
                                      formik.setFieldValue("subcategory_index", "");
                                      formik.setFieldValue("sub_category_id", "");
                                    }}
                                  />
                                  <ErrorMessage
                                    name={prop.name}
                                    component="div"
                                    className="error"
                                  />
                                </div>
                                <>
                                  {
                                    (Array.isArray(subcategory) && subcategory?.length > 0) ?
                                      <>
                                        {formik?.values?.category_id && (
                                          <div className="form-group col-md-6">
                                            <label>Select sub category</label>
                                            <ReactSelect
                                              options={
                                                Array.isArray(subcategory) &&
                                                subcategory.map((lang) => ({
                                                  value: lang.id,
                                                  label: lang.title,
                                                }))
                                              }
                                              placeholder="Select An Option"
                                              noOptionsMessage={() => "No option"}
                                              value={selectSubcategory}
                                              onChange={(options) => {
                                                setSelectSubcategory(options);
                                                formik.setFieldValue(
                                                  "sub_category_id",
                                                  options.value
                                                );
                                                formik.setFieldValue(
                                                  "subcategory_index",
                                                  options
                                                );
                                              }}
                                            />
                                            <ErrorMessage
                                              name="sub_category_id"
                                              component="div"
                                              className="error"
                                            />
                                          </div>
                                        )}
                                      </>
                                      : <></>
                                  }
                                </>
                              </div>
                            </>
                          );
                        }

                        if (prop.name == "last_date") {
                          return (
                            <div className="form-group">
                              <FieldInput
                                title={prop.title}
                                name={prop.name}
                                placeholder={prop.placeholder}
                                type='date'
                                min={getTodayDate()}
                              />
                            </div>
                          );
                        }
                        if (prop.name == "title") {
                          return (
                            <>
                              <FieldInput
                                title={prop.title}
                                name={prop.name}
                                placeholder={prop.placeholder}
                                key={key}
                              />
                              <div className="title">
                                <h5>Title examples</h5>
                                <p>Create a eye catching logo</p>
                                <p>
                                  Develop a responsive website with payment
                                  gateway functionlity
                                </p>
                                <p>
                                  Convert UI to HTML for e-commerce website etc.
                                </p>
                              </div>
                            </>
                          );
                        }
                        if (prop.name == "price") {
                          return (
                            <NumberInputBox
                              type={"number"}
                              title={prop.title}
                              name={prop.name}
                              placeholder={prop.placeholder}
                              key={key}
                            />
                          );
                        }

                        if (prop.name == "description") {
                          return (
                            <>
                              <CustomReactQuill
                                value={formik.values.description}
                                formik={formik}
                                name={prop.name}
                                title={prop.title}
                              />
                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                                style={{ color: "red" }}
                              />
                            </>
                          );
                        }

                        return (
                          <FieldInput
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      })}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container col-lg-8 col-md-11 mx-auto d-flex justify-content-end">
        <button className="next-button" onClick={handleNextClick} type="submit">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default CAboutContest;
